import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import agencyService from "services/AgencyService";
import { message } from "antd";

export const initialState = {
  loadingAgencies: false,
  loadingCreate: false,
  loadingCountries: false,
  loadingUpdate: false,
  countries: [],
  loadingAgencyById: false,
  allAgenciesLoading: false,
  allAgencies: [],
  agencies: [],
  getbyIdData: {},
  loadingAgencyStatus: false,
  allAgencyStatus: [],
  totalRecord: 0,
  status: [],
  loadingApproveReject: false,
};

export const GetAgenciesSSR = createAsyncThunk(
  "/Agency/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await agencyService.GetAgenciesSSSR(data);
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CreateAgency = createAsyncThunk(
  "/Agency/Create",
  async (data, { rejectWithValue }) => {
    try {
      try {
        const response = await agencyService.CreateAgency(data);

        if (response.success === false) {
          message.error({
            content: ` ${response.message}`,
          });
          return rejectWithValue(response.message);
        } else {
          message.success({
            content: ` ${response.message}`,
          });

          return response.result;
        }
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message || "Something Went Wrong !"
        );
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetAgencyById = createAsyncThunk(
  "/Agency/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await agencyService.GetAgencyById({ id });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetAllAgency = createAsyncThunk(
  "/Agency/GetALL",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agencyService.GetALLAgency();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetActive = createAsyncThunk(
  "/Agency/SetIsActive",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await agencyService.SetActive({ id, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const UpdateAgencies = createAsyncThunk(
  "/Agency/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await agencyService.UpdateAgency(data);

      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetCountries = createAsyncThunk(
  "/Agency/GetCountries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agencyService.GetCountries();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsApproved = createAsyncThunk(
  "/Agency/SetIsApproved",
  async ({ id, statusId }, { rejectWithValue }) => {
    try {
      const response = await agencyService.SetIsApproved({ id, statusId });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetAgencyStatus = createAsyncThunk(
  "/Agency/GetAgencyStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agencyService.GetAgencyStatus();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const agencySlice = createSlice({
  name: "agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAgenciesSSR.pending, (state) => {
        state.loadingAgencies = true;
      })
      .addCase(GetAgenciesSSR.fulfilled, (state, action) => {
        state.loadingAgencies = false;
        state.agencies = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetAgenciesSSR.rejected, (state, action) => {
        state.agencies = [];
        state.loadingAgencies = false;
      })
      .addCase(CreateAgency.rejected, (state, action) => {
        state.loadingCreate = false;
      })
      .addCase(CreateAgency.pending, (state) => {
        state.loadingCreate = true;
      })
      .addCase(CreateAgency.fulfilled, (state, action) => {
        state.loadingCreate = false;
      })
      .addCase(GetAgencyById.pending, (state) => {
        state.loadingAgencyById = true;
        state.getbyIdData = [];
      })
      .addCase(GetAgencyById.fulfilled, (state, action) => {
        state.loadingAgencyById = false;
        state.getbyIdData = action.payload;
      })
      .addCase(GetAgencyById.rejected, (state, action) => {
        state.loadingAgencyById = false;
        state.getbyIdData = [];
      })

      .addCase(GetCountries.pending, (state) => {
        state.loadingCountries = true;
      })
      .addCase(GetCountries.fulfilled, (state, action) => {
        state.loadingCountries = false;
        state.countries = action.payload;
      })
      .addCase(GetCountries.rejected, (state, action) => {
        state.countries = [];
        state.loadingCountries = false;
      })
      .addCase(UpdateAgencies.rejected, (state, action) => {
        state.loadingUpdate = false;
      })
      .addCase(UpdateAgencies.pending, (state) => {
        state.loadingUpdate = true;
      })
      .addCase(UpdateAgencies.fulfilled, (state, action) => {
        state.loadingUpdate = false;
      })
      .addCase(GetAllAgency.pending, (state) => {
        state.allAgenciesLoading = true;
      })
      .addCase(GetAllAgency.rejected, (state, action) => {
        state.allAgenciesLoading = false;
        state.allAgencies = action.payload;
      })

      .addCase(GetAllAgency.fulfilled, (state, action) => {
        state.allAgenciesLoading = false;
        state.allAgencyStatus = [];
      })
      .addCase(GetAgencyStatus.pending, (state) => {
        state.loadingAgencyStatus = true;
      })
      .addCase(GetAgencyStatus.fulfilled, (state, action) => {
        state.loadingAgencyStatus = false;
        state.allAgencyStatus = action.payload;
      })
      .addCase(GetAgencyStatus.rejected, (state, action) => {
        state.loadingAgencyStatus = false;
        state.allAgencyStatus = [];
      })
      .addCase(SetIsApproved.pending, (state) => {
        state.loadingApproveReject = true;
      })

      .addCase(SetIsApproved.fulfilled, (state, action) => {
        state.loadingApproveReject = false;
      })
      .addCase(SetIsApproved.rejected, (state, action) => {
        state.loadingApproveReject = false;
      });
  },
});

export const {} = agencySlice.actions;

export default agencySlice.reducer;
